import './info.component.scss';

// @vendors
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

// @components
import { OKLayoutMigration } from '../layout/OKLayoutMigration';
import { OKMessage } from 'commonsComponents/OKMessage';

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
import { recordLinkV2, recordProcess } from 'utilities/tagging';

// @constants
import { migrationKeys } from '../../migrationUsersBranchView.poeditor';
import { migrationInfoKeys } from './info.component.poeditor';
import {
  MIGRATION_STATE,
  MODAL_TYPE,
  PRECONTRACTUALS_PATH,
} from '../../migrationUsersBranchView.constants';
import { analyticsId, catalogue } from './analytics/info.tracking';
import { getDocumentLink, isItWebViewPlatform } from '../../utilities/migration.utils';
import MbPdfHybrid from '../pdfHybrid/mb-pdf-hybrid/mb-pdf-hybrid';

const step1Logo = require('assets/icons/group.svg');
const step2Logo = require('assets/icons/group-2.svg');

export const Info = ({ handleExitLeaveModal, handleChangeMigrationState }) => {
  const history = useHistory();
  const [isPdfOpen, setIsPdfOpen] = useState(false);
  const immScreen = useSelector(state => state.screen);

  useEffect(() => {
    window.utag_last_name = '/migration/step0/information';
    recordProcess('proc-migracion', 'paso_0', catalogue[analyticsId.INFO_VIEW](), true);
  }, []);

  const handleGoToPG = () => {
    if (immScreen.get('desktop')) {
      history.push('/myprofile/global');
    } else {
      window.location.href = '/myprofile/global/';
    }
  };

  const handleClick = e => {
    e?.preventDefault();
    if (isItWebViewPlatform()) {
      setIsPdfOpen(true);
    } else {
      window.open(getDocumentLink(PRECONTRACTUALS_PATH), '_system');
    }
  };

  const onModalClose = () => {
    setIsPdfOpen(false);
  };

  return (
    <>
      <OKLayoutMigration
        header={{
          leftSideText: formatText(migrationKeys.headerStartText),
          exitButton: {
            handleClickButton: () => {
              recordLinkV2(catalogue[analyticsId.EXIT_HEADER_BUTTON]());
              handleGoToPG();
            },
          },
        }}
        footer={{
          leftSideLink: {
            text: formatText(migrationInfoKeys.cancelMigrationLink),
            handler: () => {
              recordLinkV2(catalogue[analyticsId.CANCEL_MIGRATION_LINK]());
              handleExitLeaveModal(MODAL_TYPE.NOT_MIGRATE);
            },
          },
          rightSideButton: {
            text: formatText(migrationKeys.goToMigrationButton),
            handler: () => {
              recordLinkV2(catalogue[analyticsId.MIGRATE_BUTTON]());
              handleChangeMigrationState(MIGRATION_STATE.TERMS_AND_CONDITIONS);
            },
          },
        }}
      >
        <div>
          <div className="migration-info__title">
            <FormattedText value={migrationInfoKeys.title} />
          </div>
          <div className="migration-info__description">
            <FormattedText value={migrationInfoKeys.description} />
          </div>
          <div className="migration-info__steps">
            <div className="migration-info__steps--step1">
              <img className="migration-info__steps--icon" src={step1Logo} />
              <FormattedText value={migrationInfoKeys.step1Title} />
            </div>
            <div className="migration-info__steps--step2">
              <img className="migration-info__steps--icon" src={step2Logo} />
              <div className="migration-info__steps--step2--content">
                <FormattedText value={migrationInfoKeys.step2Title} />
                <div className="migration-info__steps--step2--content--description">
                  <FormattedText value={migrationInfoKeys.step2Description} />
                </div>
              </div>
            </div>
          </div>
          <OKMessage type="informative" title={formatText(migrationInfoKeys.messageTitle)}>
            <FormattedText value={migrationInfoKeys.messageDescription} />
          </OKMessage>
          <div className="migration-info__continue--description">
            <FormattedText value={migrationInfoKeys.continueDescription1} />
            <a onClick={handleClick}>{formatText(migrationInfoKeys.dataProtectionLink)}</a>
            <FormattedText value={migrationInfoKeys.continueDescription2} />
          </div>
        </div>
      </OKLayoutMigration>
      <MbPdfHybrid
        isOpen={isPdfOpen}
        file={getDocumentLink(PRECONTRACTUALS_PATH)}
        filetype={'url'}
        filename={formatText(migrationInfoKeys.dataProtectionLink)}
        title={formatText(migrationInfoKeys.dataProtectionLink)}
        onClose={onModalClose}
        linkText={migrationInfoKeys.readyLink}
      />
    </>
  );
};

Info.propTypes = {
  handleExitLeaveModal: PropTypes.func.isRequired,
};
